import $ from "jquery";

const init = () => {
  attachNavListener();
};

const attachNavListener = () => {
  $(".nav-terms").on("click", function () {
    let idx = $(".nav-terms").index(this);

    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(`.terms-content:eq(${idx})`).offset().top - 180,
      },
      500
    );
  });
};

try {
  init();
} catch (error) {
  console.error(error);
}
